import { AppButtonService } from '@office-start/app-button-service';
import { ReplaySubject } from 'rxjs';
var AppbarConnectorService = /** @class */ (function () {
    function AppbarConnectorService() {
        this.appButtonService = new AppButtonService();
        this.currentAppIconPositionSubject = new ReplaySubject(1);
    }
    Object.defineProperty(AppbarConnectorService.prototype, "userClickTime", {
        /**
         * get time user clicked on the app tile
         */
        get: function () {
            return this._userClickTime;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * move focus to currently active app's tile on app bar
     */
    AppbarConnectorService.prototype.focusOnAppbar = function () {
        if (!this.onReturnFocus) {
            return;
        }
        this.onReturnFocus();
    };
    /**
     * register function for setting focus to currently active app's tile on app bar
     */
    AppbarConnectorService.prototype.setOnReturnFocus = function (callback) {
        this.onReturnFocus = callback;
    };
    /**
     * set callback for getting appIcon's position from appbar
     * @param callback
     */
    AppbarConnectorService.prototype.setGetAppIconPositionRect = function (callback) {
        this.getAppIconPositionRect = callback;
    };
    /**
     * set callback for getting appIcon's element ref from appbar
     * @param callback
     */
    AppbarConnectorService.prototype.setGetAppIconElementRef = function (callback) {
        this.getAppIconElementRef = callback;
    };
    AppbarConnectorService.prototype.setInteractiveFunctions = function (instance) {
        this.setOnReturnFocus(function () { return instance === null || instance === void 0 ? void 0 : instance.focus(); });
        this.setGetAppIconPositionRect(function (id) {
            return instance === null || instance === void 0 ? void 0 : instance.getAppIconPositionRect(id);
        });
        this.setGetAppIconElementRef(function (id) {
            return instance === null || instance === void 0 ? void 0 : instance.getAppIconElementRef(id);
        });
    };
    /**
     * Callback for app button click
     */
    AppbarConnectorService.prototype.onAppButtonClick = function (clickTime, isAppRunning) {
        this._userClickTime = clickTime;
        if (isAppRunning) {
            //fire click event for app to trigger callback on currently running app tile click in app bar
            this.appButtonService.dispatchEvent('click', {});
        }
    };
    /**
     * fire hoverEnter event for app to trigger callback on currently running app tile hover enter in app bar
     */
    AppbarConnectorService.prototype.onAppButtonHoverEnter = function () {
        this.appButtonService.dispatchEvent('hoverEnter', {});
    };
    /**
     * fire hoverLeave event for app to trigger callback on currently running app tile hover leave in app bar
     */
    AppbarConnectorService.prototype.onAppButtonHoverLeave = function () {
        this.appButtonService.dispatchEvent('hoverLeave', {});
    };
    /**
     * return AppButtonService instance
     */
    AppbarConnectorService.prototype.getAppButtonService = function () {
        return this.appButtonService;
    };
    /**
     * Update currently running app's icon's vertical position information
     */
    AppbarConnectorService.prototype.updateCurrentAppVerticalPosition = function () {
        var _a, _b;
        var val = (_b = (_a = this.getAppIconPositionRect) === null || _a === void 0 ? void 0 : _a.call(this)) === null || _b === void 0 ? void 0 : _b.top;
        if (val) {
            this.currentAppIconPositionSubject.next(val);
        }
    };
    /**
     * Return observable for getting latest vertical position value for currently running app's icon
     * @returns
     */
    AppbarConnectorService.prototype.getCurrentAppIconPositionObservable = function () {
        return this.currentAppIconPositionSubject.asObservable();
    };
    return AppbarConnectorService;
}());
export { AppbarConnectorService };
//# sourceMappingURL=AppbarConnectorService.js.map